import React, { Component } from 'react';
import { ajax_wrapper } from 'functions';
import $ from 'jquery';

export default class FaqChatbot extends Component {
    constructor(props) {
        super(props);
        
        // Detect if it homepage, underpaying, or overpaying flow type first
        const flowType = this.detectFlowType();
        
        // Create appropriate welcome message
        const welcomeMessage = this.getWelcomeMessageForFlow(flowType);
        
        this.state = {
            isOpen: false,
            messages: [
                {
                    text: welcomeMessage,
                    isBot: true,
                }
            ],
            userInput: '',
            isLoading: false,
            conversationId: '',
            flowType: flowType,
            previousFlowType: null
        };
        this.messagesEndRef = React.createRef();
    }
    
    getWelcomeMessageForFlow = (flowType) => {
        if (flowType === 'overpaying') {
            return "I see you're overpaying on your property taxes! I'm here to help you file an appeal and save money. What questions do you have about the process?";
        } else if (flowType === 'underpaying') {
            return "Good news! You're currently underpaying on property taxes. I can help you explore other ways to save on home expenses. What would you like to know?";
        } else {
            return "Hi! I'm your HomeBase assistant. Ask me any questions about property taxes or our services!";
        }
    }

    detectFlowType = () => {
        // Check the current URL to determine if we're in overpaying or underpaying flow
        const currentPath = window.location.pathname;
        const currentHash = window.location.hash;
        
        // Check for session storage first
        const storedFlowType = sessionStorage.getItem('homebase_flow_type');
        if (storedFlowType) {
            return storedFlowType;
        }
        
        // Detect investors page (home/landing page)
        if (currentPath === '/' || currentPath === '/investors/' || 
            document.getElementById('propertysearch') && !document.querySelector('.gradient-background-overpaying') && 
            !document.querySelector('.gradient-background-underpaying')) {
            return '';
        }
        
        // Try to detect from URL or page content
        if (document.body.innerHTML.includes('Overpaying') || 
            currentHash.includes('comparables') || 
            document.querySelector('.gradient-background-overpaying')) {
            return 'overpaying';
        } else if (document.body.innerHTML.includes('Underpaying') || 
                document.querySelector('.gradient-background-underpaying')) {
            return 'underpaying';
        }
        
        return ''; // Default empty if we can't detect
    }
    
    resetConversation = () => {
        // Get the current flow type
        const currentFlowType = this.detectFlowType();
        
        // Create welcome message based on current flow
        const welcomeMessage = this.getWelcomeMessageForFlow(currentFlowType);
        
        // Reset the conversation
        this.setState({
            messages: [
                {
                    text: welcomeMessage,
                    isBot: true,
                }
            ],
            conversationId: '',
            userInput: '',
            flowType: currentFlowType
        });
        
        // Clear localStorage items related to conversation
        localStorage.removeItem('homebase_chat_messages');
        localStorage.removeItem('homebase_conversation_id');
        
        // Update flow type in localStorage
        localStorage.setItem('homebase_flow_type', currentFlowType);
    }

    componentDidMount() {
        // Load conversation from localStorage if it exists
        const savedConversation = localStorage.getItem('homebase_chat_messages');
        const savedConversationId = localStorage.getItem('homebase_conversation_id');
        const savedFlowType = localStorage.getItem('homebase_flow_type');
        const currentFlowType = this.detectFlowType();
        
        // Store the current flow type for comparison
        this.setState({ previousFlowType: savedFlowType });
        
        // If we have a saved conversation
        if (savedConversation) {
            try {
                const parsedMessages = JSON.parse(savedConversation);
                
                // Set the saved messages and conversation ID
                this.setState({ 
                    messages: parsedMessages,
                    conversationId: savedConversationId || '',
                    flowType: currentFlowType || savedFlowType || ''
                });
                
                // If flow type changed and this is a new page (not just a refresh), add a context message
                if (currentFlowType && savedFlowType !== currentFlowType) {
                    // Add a contextual message but don't reset the conversation
                    this.addContextualMessage(currentFlowType);
                }
            } catch (e) {
                console.error('Error parsing saved conversation:', e);
                this.resetConversation();
            }
        } else {
            // No existing conversation, just set the default welcome message
            this.resetConversation();
        }
    }

    // Adds a contextual message based on the flow type without resetting conversation
    addContextualMessage = (flowType) => {
        // Only add contextual messages if the conversation has more than just the welcome message
        if (this.state.messages.length <= 1) {
            // Just update the flow type without adding another message
            this.setState({ flowType: flowType });
            localStorage.setItem('homebase_flow_type', flowType);
            return;
        }
        
        let contextMessage = "";
        
        // Create appropriate context message based on flow type
        if (flowType === 'overpaying') {
            contextMessage = "I notice you're now looking at an overpaying property. I can help you file an appeal and save money. What questions do you have?";
        } else if (flowType === 'underpaying') {
            contextMessage = "I see you're now viewing an underpaying property. I can still help you find other ways to save on home expenses.";
        } else {
            contextMessage = "Welcome back to the homepage! How else can I help you with property taxes or our services?";
        }
        
        if (contextMessage) {
            // Add the contextual message to the conversation
            const newMessages = [...this.state.messages, { text: contextMessage, isBot: true }];
            this.setState({
                messages: newMessages,
                flowType: flowType
            });
            
            // Update flow type in localStorage
            localStorage.setItem('homebase_flow_type', flowType);
            localStorage.setItem('homebase_chat_messages', JSON.stringify(newMessages));
        }
    }
    
    componentDidUpdate() {
        // Check if flow type has changed
        const currentFlowType = this.detectFlowType();
        if (currentFlowType && 
            this.state.previousFlowType !== currentFlowType && 
            this.state.flowType !== currentFlowType) {
            
            // Update previous flow type
            this.setState({ 
                previousFlowType: currentFlowType,
                flowType: currentFlowType
            });
            
            // Add contextual message but don't reset conversation
            this.addContextualMessage(currentFlowType);
        }
        
        // Scroll to bottom if messages changed
        if (this.messagesEndRef.current) {
            this.scrollToBottom();
        }
        
        // Save conversation to localStorage
        localStorage.setItem('homebase_chat_messages', JSON.stringify(this.state.messages));
        if (this.state.conversationId) {
            localStorage.setItem('homebase_conversation_id', this.state.conversationId);
        }
        if (this.state.flowType) {
            localStorage.setItem('homebase_flow_type', this.state.flowType);
        }
    }

    scrollToBottom = () => {
        this.messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }

    toggleChatbot = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }

    handleInputChange = (e) => {
        this.setState({ userInput: e.target.value });
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.sendMessage();
        }
    }

    sendMessage = () => {
        const { userInput, messages } = this.state;
        
        if (userInput.trim() === '') return;
        
        const newMessages = [...messages, { text: userInput, isBot: false }];
        
        this.setState({
            messages: newMessages,
            userInput: '',
            isLoading: true
        });
        
        // Send the user's message to the OpenAI API
        this.fetchBotResponse(userInput);
    }

    fetchBotResponse = (userMessage) => {
        const { conversationId, flowType } = this.state;
        
        const data = {
            user_message: userMessage,
            conversation_id: conversationId,
            flow_type: flowType
        };
        
        ajax_wrapper(
            'POST',
            '/api/faq_chatbot/',
            data,
            this.handleBotResponse  // This will handle both success and error cases
        );
    }

    handleBotResponse = (data) => {
        // Check if there's an error in the response
        if (data && data.error) {
            console.error('Error in bot response:', data.error);
            
            const { messages } = this.state;
            const newMessages = [...messages, { 
                text: "Sorry, I'm having trouble connecting right now. Please try again later.", 
                isBot: true 
            }];
            
            this.setState({
                messages: newMessages,
                isLoading: false
            });
            return;
        }
        
        const { messages } = this.state;
        const newMessages = [...messages, { text: data.response, isBot: true }];
        
        this.setState({
            messages: newMessages,
            isLoading: false,
            conversationId: data.conversation_id || this.state.conversationId
        });
    }

    render() {
        const { isOpen, messages, userInput, isLoading, flowType } = this.state;
        
        const toggleButtonStyle = {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            width: '70px',
            height: '70px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #5E51F7, #F75E51)',
            color: 'white',
            border: 'none',
            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '28px',
            zIndex: 1000,
            transition: 'transform 0.2s ease-in-out',
            '&:hover': {
                transform: 'scale(1.1)',
            }
        };
        
        const chatboxStyle = {
            position: 'fixed',
            bottom: '90px',
            right: '20px',
            width: '450px',
            height: '600px',
            borderRadius: '16px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            display: isOpen ? 'flex' : 'none',
            flexDirection: 'column',
            background: 'white',
            zIndex: 1000,
            overflow: 'hidden',
        };
        
        const headerStyle = {
            padding: '15px',
            background: 'linear-gradient(135deg, #5E51F7, #F75E51)',
            color: 'white',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        };
        
        const messagesContainerStyle = {
            flex: 1,
            overflowY: 'auto',
            padding: '15px',
            display: 'flex',
            flexDirection: 'column',
        };
        
        const inputContainerStyle = {
            display: 'flex',
            padding: '10px',
            borderTop: '1px solid #e0e0e0',
        };
        
        const inputStyle = {
            flex: 1,
            padding: '10px',
            border: '1px solid #e0e0e0',
            borderRadius: '20px',
            marginRight: '10px',
            outline: 'none',
        };
        
        const sendButtonStyle = {
            background: 'linear-gradient(135deg, #5E51F7, #F75E51)',
            color: 'white',
            border: 'none',
            borderRadius: '20px',
            padding: '0 15px',
            cursor: 'pointer',
        };
        
        const resetButtonStyle = {
            background: 'transparent',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            marginRight: '10px',
        };
        
        return (
            <>
                <button 
                    style={toggleButtonStyle} 
                    onClick={this.toggleChatbot}
                    title="Chat with HomeBase Assistant"
                >
                    <i className={`bi bi-${isOpen ? 'x' : 'chat-dots-fill'}`}></i>
                </button>
                
                <div style={chatboxStyle}>
                    <div style={headerStyle}>
                        <span>HomeBase Assistant</span>
                        <div>
                            <button 
                                style={resetButtonStyle}
                                onClick={this.resetConversation}
                                title="Reset conversation"
                            >
                                <i className="bi bi-arrow-counterclockwise"></i>
                            </button>
                            <i 
                                className="bi bi-x" 
                                style={{ cursor: 'pointer' }}
                                onClick={this.toggleChatbot}
                            ></i>
                        </div>
                    </div>
                    
                    <div style={messagesContainerStyle}>
                        {messages.map((message, index) => (
                            <div 
                                key={index}
                                style={{
                                    alignSelf: message.isBot ? 'flex-start' : 'flex-end',
                                    background: message.isBot 
                                        ? '#f0f0f0' 
                                        : 'linear-gradient(135deg, #5E51F7, #F75E51)',
                                    color: message.isBot ? '#333' : 'white',
                                    padding: '10px 15px',
                                    borderRadius: '18px',
                                    margin: '5px 0',
                                    maxWidth: '80%',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {message.text}
                            </div>
                        ))}
                        {isLoading && (
                            <div 
                                style={{
                                    alignSelf: 'flex-start',
                                    background: '#f0f0f0',
                                    color: '#333',
                                    padding: '10px 15px',
                                    borderRadius: '18px',
                                    margin: '5px 0',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div className="typing-indicator">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        )}
                        <div ref={this.messagesEndRef} />
                    </div>
                    
                    <div style={inputContainerStyle}>
                        <input 
                            type="text"
                            placeholder="Ask a question..."
                            value={userInput}
                            onChange={this.handleInputChange}
                            onKeyDown={this.handleKeyPress}
                            style={inputStyle}
                        />
                        <button 
                            onClick={this.sendMessage}
                            style={sendButtonStyle}
                            disabled={isLoading}
                        >
                            <i className="bi bi-send"></i>
                        </button>
                    </div>
                </div>
                
                <style jsx="true">{`
                    .typing-indicator {
                        display: flex;
                        align-items: center;
                    }
                    
                    .typing-indicator span {
                        height: 8px;
                        width: 8px;
                        background-color: #555;
                        border-radius: 50%;
                        display: inline-block;
                        margin: 0 2px;
                        animation: typing 1.5s infinite ease-in-out;
                    }
                    
                    .typing-indicator span:nth-child(2) {
                        animation-delay: 0.2s;
                    }
                    
                    .typing-indicator span:nth-child(3) {
                        animation-delay: 0.4s;
                    }
                    
                    @keyframes typing {
                        0% {
                            transform: translateY(0px);
                            opacity: 0.7;
                        }
                        50% {
                            transform: translateY(-5px);
                            opacity: 1;
                        }
                        100% {
                            transform: translateY(0px);
                            opacity: 0.7;
                        }
                    }
                `}</style>
            </>
        );
    }
} 